import axios from "axios";

export const contactForm = (data: {
  firstName: string;
  lastName: string;
  email: string;
  message: string;
  subject: string;
  phone: string;
  token: string;
}) => {
  return new Promise((resolve, reject) => {
    axios({
      url: `${process.env.NEXT_PUBLIC_API_URL}/contact/`,
      method: "post",
      data,
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
